import { IDefineCommand, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IPlanFeedbackCourse, PlanFeedbackCourse } from '../builders/plan_feedback_course_builder';
import { IPlanFeedbackCourseGroup } from '../builders/plan_feedback_course_group_builder';
import { PlanFeedbackProgramSlot } from '../builders/plan_feedback_program_slot_builder';
import { PlanFeedbackTerm } from '../builders/plan_feedback_term_builder';
import { IPlanFeebackCourseGroupsDatasource } from '../datasources/plan_feedback_course_groups_datasource';
import { IPlanFeebackCoursesDatasource } from '../datasources/plan_feedback_courses_datasource';
import { IPlanFeedbackProgramSlotsDatasource } from '../datasources/plan_feedback_program_slots_datasource';
import { IPlanFeebackTermsDatasource } from '../datasources/plan_feedback_terms_datasource';
import { FeedbackSuggestedPlanModel, IFeedbackSuggestedPlanModel } from '../models/feedback_suggested_plan_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadPlanFeedbackCommand',
    function loadPlanFeedbackCommand(
      $http: ng.IHttpService,
      log: any,
      defineCommandORM: IDefineCommand,
      ngPlanFeebackCourseGroupsDatasource: IPlanFeebackCourseGroupsDatasource,
      ngPlanFeebackCoursesDatasource: IPlanFeebackCoursesDatasource,
      ngPlanFeebackTermsDatasource: IPlanFeebackTermsDatasource,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      ngPlanFeedbackProgramSlotsDatasource: IPlanFeedbackProgramSlotsDatasource
    ) {
      return defineCommandORM('loadPlanFeedbackCommand', (deferred: any) => {
        interface IPlanFeedbackApiReponse {
          feedback_course_groups: IPlanFeedbackCourseGroup[];
          feedback_courses: PlanFeedbackCourse[];
          feedback_terms: PlanFeedbackTerm[];
          suggested_plan: IFeedbackSuggestedPlanModel;
          feedback_programslot_statuses: PlanFeedbackProgramSlot[];
        }

        $http
          .get(`/academicplan/suggested_plan/${ngFeedbackSuggestedPlanModel.read().id}/diff_from_resolutions`)
          .then((response: any) => {
            const data: IPlanFeedbackApiReponse = response.data;
            // This needs to be first as feedback course group/feedback course requires this entry to be there
            ngPlanFeedbackProgramSlotsDatasource.clear().write(data.feedback_programslot_statuses);

            ngPlanFeebackCoursesDatasource.clear().write(data.feedback_courses);

            ngPlanFeebackCourseGroupsDatasource.clear().write(data.feedback_course_groups);

            ngPlanFeebackTermsDatasource.clear().write(data.feedback_terms);

            ngFeedbackSuggestedPlanModel.write(data.suggested_plan);

            ngPlanFeedbackProgramSlotsDatasource.clear().write(data.feedback_programslot_statuses);
            deferred.resolve();
          })
          .catch((e) => {
            deferred.reject(e);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/commands/load_plan_feedback_command.ts